import React, { useState, useEffect } from "react";

// Css
import "./UnderMaintenance.css";

// Images
import UnderMaintenanceLogo from "./UnderMaintenanceLogo.svg";

// Material Ui
// #Elements
import Button from "@material-ui/core/Button";

function UnderMaintenance() {
  const ADMIN_KEY = "940818fc-ef3d-45ed-b14a-e2cf3eab3bf2";
  const [enter, setEnter] = useState(false);

  useEffect(() => {
    const url_string = window.location.href;
    const url = new URL(url_string);
    const admin = url.searchParams.get("admin");
    const admin_key = url.searchParams.get("admin_key");
    console.log(admin);
    if (
      (admin == process.env.REACT_APP_ADMIN_KEY && admin != null) ||
      admin_key == ADMIN_KEY
    ) {
      setEnter(true);
      localStorage.setItem("admin_key", ADMIN_KEY);
    } else if (localStorage.getItem("admin_key") === ADMIN_KEY) {
      setEnter(true);
    }
  }, []);

  const enterSite = () => {
    let warningMessage = window.confirm(
      "[Note]: Since this site is still in beta testing, please expect bugs and faulty functions. \n \nAre you sure you want to proceed anyways?"
    );

    if (warningMessage) {
      setEnter(true);
    }
  };

  const UnderMaintenanceWindow = (
    <div className="underMaintenance">
      <img src={UnderMaintenanceLogo} className="underMaintenance__logo" />
      <div>
        <h3>This site is under maintenance.</h3>
      </div>
      {/* <Button variant="contained" color="primary" onClick={enterSite}>
        Enter anyway
      </Button> */}
    </div>
  );

  return <>{!enter ? UnderMaintenanceWindow : null}</>;
}

export default UnderMaintenance;
